<template>
    <div>
        <div class="el-form-card__header el-form-card__header-center">
            {{ $t('title.unloadingAreas') }}
        </div>
        <div class="el-form-card__element-wrapper">
            <div class="el-radio-list">
                <v-radio-group class="calendar-filter-list-group">
                    <v-layout
                        v-for="unloadingArea in unloadingAreas"
                        :key="unloadingArea.UnloadingAreaID"
                    >
                        <v-flex xs1>
                            <v-checkbox
                                :value="unloadingArea"
                                :input-value="unloadingArea"
                                v-model="unloadingAreaList"
                                color="success"
                                hide-details
                            />
                        </v-flex>
                        <v-flex xs11>
                            <span
                                class="unloading-area"
                                style="background: #fea47f; display: table"
                                :style="{
                                    background: unloadingArea.Color,
                                    border:
                                        selectedUnloadingArea &&
                                        selectedUnloadingArea.UnloadingAreaID ===
                                            unloadingArea.UnloadingAreaID
                                            ? 'solid 1.5px #fff'
                                            : '',
                                }"
                                @click="handleUnloadingArea(unloadingArea)"
                            >
                                {{ unloadingArea.ShortDescription }}
                            </span>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="showPass">
                        <v-flex xs1>
                            <v-checkbox
                                v-model="unloadingAreaList"
                                v-if="showPass"
                                color="success"
                                :value="null"
                                hide-details
                            />
                        </v-flex>
                        <v-flex xs11>
                            <span
                                class="unloading-area"
                                style="background: #fea47f"
                            >
                                {{ $t('table.filter.text.pass') }}
                            </span>
                        </v-flex>
                    </v-layout>
                </v-radio-group>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'stc-unloading-areas-selctor',

    props: {
        unloadingAreas: Array,
        showPass: false,
    },

    data() {
        return {
            selectedUnloadingArea: '',
            unloadingAreaList: [],
        }
    },

    created() {
        this.unloadingAreaList = [null, ...this.unloadingAreas]
    },

    watch: {
        unloadingAreaList() {
            this.$emit('unloading-area-checked', this.unloadingAreaList)
        },

        unloadingAreas(data) {
            if (data) {
                this.unloadingAreaList = [null, ...data]
            }
        },
    },

    methods: {
        handleUnloadingArea(unloadingArea) {
            this.selectedUnloadingArea = unloadingArea
            this.$emit('unloading-area-selected', unloadingArea)
        },
    },
}
</script>